import InnerPop from '../newPopup/innerPop/InnerPop';
import {TShow} from '../prompotionPopup/PromotionPopup';
import * as css from './WhatsAppTermsPopup.css';
import {useTranslation} from 'react-i18next';
import {updateUserPreferences} from '../../redux/user/userActions';
import CustomScrollbar from '../customScrollbar/CustomScrollbar';
import {useRef, useState, useEffect} from 'react';
import {mobileMedia} from '../../globalVariables/GlobalVariables';
import Loader from '../loader/Loader';

function WhatsAppTermsPopup({show}: { show: TShow }) {
    const {t} = useTranslation('whatsapp');
    const scrollRef = useRef(null);
    const [isLoading, setIsLoading] = useState(true);
    
    useEffect(() => {
        // Show loader for 3 seconds when component mounts
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 300);
        
        return () => clearTimeout(timer);
    }, []);
    
    const cssStyle = `
        inset-inline-end: 20px;
        inset-block-start: 65px;
        ${mobileMedia} {
           display: none;
        }
    `;
    
    return (
        <css.wrapper>
            <InnerPop
                show={show}
                title={''}
                dataCy={'whatsappTerms'}
                buttons={{
                    whiteBtn: {
                        text: t('termsClose'),
                        onClick: async () => {
                            updateUserPreferences({hideWhatsappTerms: true}).then();
                            show.close();
                        }
                    },
                    blueBtn: {
                        text: t('termsAccept'),
                        onClick: show.close
                    }
                }}
            >
                <CustomScrollbar contentRef={scrollRef} cssStyle={cssStyle}  />
                <css.content ref={scrollRef}>
                    <Loader XHR={isLoading ? 'LOADING' : 'SUCCESS'} height={undefined}>
                        {!isLoading && (
                            <>
                                <css.title>{t('mainTitle')}</css.title>
                                <css.list>
                                    <css.item>{t('templateText')}</css.item>
                                    <css.item>
                                        <css.subList>
                                            <css.subItem><span>•</span>{t('recipientInfo')}</css.subItem>
                                            <css.subItem><span>•</span>{t('arrivalInstructions')}</css.subItem>
                                            <css.subItem><span>•</span>{t('venueRequirements')}</css.subItem>
                                            <css.subItem><span>•</span>{t('showDetails')}</css.subItem>
                                            <css.subItem><span>•</span>{t('scheduleChanges')}</css.subItem>
                                        </css.subList>
                                    </css.item>
                                    <css.item>{t('important')}</css.item>
                                    <css.item>
                                        <css.subList>
                                            <css.subItem><span>•</span>{t('segments')}</css.subItem>
                                            <css.subItem><span>•</span>{t('noLinks')}</css.subItem>
                                            <css.subItem><span>•</span>{t('noLineBreaks')}</css.subItem>
                                            <css.subItem><span>•</span>{t('contentPolicy')}</css.subItem>
                                        </css.subList>
                                    </css.item>
                                    <css.item>{t('ensureDelivery')}</css.item>
                                </css.list>
                            </>
                        )}
                    </Loader>
                </css.content>
            </InnerPop>
        </css.wrapper>
    );
}

export default WhatsAppTermsPopup; 